<template>
	<div>
		<h3>签到设置</h3>
		<el-button @click="openEdit()" type="primary" style="float: right; margin: 10px;">新建</el-button>
		<el-table :data="list" :header-cell-style="{'text-align':'center','background':'#F2F2F4'}"
			:cell-style="{'text-align':'center'}">
			<el-table-column label="次数">
				<template slot-scope="scope">
					签到 {{scope.row.sign}} 次
				</template>
			</el-table-column>
			<el-table-column label="获得券/券包">
				<template slot-scope="scope">
					{{scope.row.coupon==0? scope.row.couponName : scope.row.couponPackageName}}
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button type="text" @click="openEdit(scope.row.id)">编辑</el-button>
					<el-button type="text" @click="deleteSign(scope.row.id)" style="color: #ff0000;">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 编辑新建弹窗 -->
		<el-dialog title="签到奖励" :visible.sync="editWindow" width="40%">
			<el-form>
				<el-form-item label="签到">
					<el-input v-model="sendData.sign" type="number" min="0" style="width: 100px;"></el-input> 次
				</el-form-item>
				<el-form-item label="获得">
					<el-radio-group v-model="sendData.coupon">
						<el-radio key="0" label="0" value="0">券</el-radio>
						<el-radio key="1" label="1" value="1">券包</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="选择券" v-if="sendData.coupon==0">
					<el-tag>id:{{sendData.couponId}}</el-tag>
					<el-button size="mini" style="color:#999; border:2px dashed;margin-left:30px;"
						@click="couponWindow = true">+选择优惠劵</el-button>
				</el-form-item>
				<el-form-item label="选择券包" v-if="sendData.coupon==1">
					<el-tag>id:{{sendData.couponId}}</el-tag>
					<el-button size="mini" style="color:#999; border:2px dashed;margin-left:30px;"
						@click="couponPackageWindow = true">+选择劵包</el-button>
				</el-form-item>
			</el-form>
			<el-button style="margin-left:70%" @click="editWindow=false">取消</el-button>
			<el-button type="primary" @click="editWindow=false,save()">确定</el-button>
		</el-dialog>
		<!-- 优惠券弹窗 -->
		<el-dialog title="选择优惠劵" :visible.sync="couponWindow" width="60%">
			<el-form inline>
				<el-form-item>
					<el-input v-model="couponFilter.name" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getCouponList">筛选</el-button>
				</el-form-item>
				<div style="float: right;">
					<el-button @click="couponWindow=false">取消</el-button>
					<el-button type="primary" @click="couponWindow=false">确定</el-button>
				</div>
			</el-form>
			<el-table :data="couponList" height="500">
				<el-table-column label="选择" width="100">
					<template slot-scope="scope">
						<el-radio-group v-model="sendData.couponId" style="width: 20px; overflow: hidden;">
							<el-radio :label="scope.row.id"></el-radio>
						</el-radio-group>
						{{scope.row.id}}
					</template>
				</el-table-column>
				<el-table-column prop="title" label="劵名称">
					<template slot-scope="scope">
						{{ scope.row.title }}
					</template>
				</el-table-column>
				<el-table-column prop="storeNames" label="使用范围">
					<template slot-scope="scope">
						{{ scope.row.storeNames.toString() }}
					</template>
				</el-table-column>
				<!-- 				<el-table-column prop="content" label="劵内容" width="120">
					<template slot-scope="scope">
						{{ scope.row.content }}
					</template>
				</el-table-column> -->
				<el-table-column prop="termOfValidity" label="有效期" width="180">
					<template slot-scope="scope">
						{{ scope.row.termOfValidity }}
					</template>
				</el-table-column>
				<el-table-column label="领取/总量" width="120">
					<template slot-scope="scope">
						{{ scope.row.getNum }} / {{ scope.row.totalNum }}
					</template>
				</el-table-column>
				<el-table-column prop="useNum" label="已使用" width="80">
					<template slot-scope="scope">
						{{ scope.row.useNum }}
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background @current-change="couponPage" layout="prev, pager, next"
				:total="couponFilter.total">
			</el-pagination>
		</el-dialog>
		<!-- 券包弹窗-->
		<el-dialog :visible.sync="couponPackageWindow" width="60%">
			<div class="title" style="margin-top:-10px;">
				<div class="blue"></div>
				<div style="flex: 1; font-size: 18px;">选择券包</div>
			</div>
			<div>
				<el-table :cell-style="{'text-align':'center'}"
					:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable"
					:data="couponPackageList" tooltip-effect="dark" style="width: 100%">
					<!-- 					<template slot-scope="scope">
						<el-button @click="couponPackageWindow = false">取 消</el-button>
						<el-button type="primary" @click="couponPackageWindow = false,selectCouponPackage(scope.row.title)">确 定</el-button>
					</template> -->
					<el-table-column label="券包ID" width="100px">
						<template scope="scope">
							<el-radio :label="scope.row.id" v-model="sendData.couponId"></el-radio>
						</template>
					</el-table-column>
					<el-table-column prop="name" align="center" label="名称"></el-table-column>
					<el-table-column prop="termOfValidity" label="有效期"></el-table-column>
				</el-table>
				<el-pagination background @current-change="couponPackagePage" layout="prev, pager, next"
					:total="couponPackageFilter.total">
				</el-pagination>
				<el-button style="margin-left:70%" @click="couponPackageWindow=false">取消</el-button>
				<el-button type="primary" @click="couponPackageWindow=false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				sendData: [],
				editWindow: false, //编辑弹窗
				couponWindow: false, //优惠券弹窗
				couponTitle: '', //选择优惠券名称
				couponPackageTitle: '', //选择券包名称
				couponPackageWindow: false, //优惠券包弹窗
				couponObj: undefined, //选择的券id
				filter: {
					pageNum: 1,
					pageSize: 10,
					total: 100
				},
				filter2: {
					pageNum: 1,
					pageSize: 10,
					total: 100
				},
				couponList: [],
				couponPackageList: [],
				couponFilter: {
					name: undefined,
					pageNum: 1,
					pageSize: 10,
					total: 0,
				},
				couponPackageFilter: {
					name: undefined,
					pageNum: 1,
					pageSize: 10,
					total: 0,
				}
			}
		},
		mounted() {
			this.getSignList()
			this.getCouponList()
			this.getCouponPackage()
		},
		methods: {
			// 获取签到奖励
			getSignList(couponId) {
				this.$http.get("marketing/sign" + "?couponId=" + couponId).then(res => {
					this.list = res.body.data;
					for (let i = 0; i < this.list.length; i++) {
						this.list[i].coupon = res.body.data[i].coupon.toString()
					}
					if (couponId != '' && couponId != undefined) {
						this.sendData = res.body.data[0];
					}
				})
			},
			// 新建或保存
			save() {
				var a;
				if (this.sendData.id != null && this.sendData.id != undefined) {
					a = "?id=" + this.sendData.id +
						"&sign=" + this.sendData.sign +
						"&coupon=" + this.sendData.coupon +
						"&couponId=" + this.sendData.couponId;
				} else {
					a = "?sign=" + this.sendData.sign +
						"&coupon=" + this.sendData.coupon +
						"&couponId=" + this.sendData.couponId;
				}
				this.$http.get("marketing/saveSign" + a).then(res => {
					if (res.body.code == 200) {
						this.$message.success("保存成功！")
						this.getSignList();
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			// 打开编辑弹窗
			openEdit(id) {
				this.sendData = [];
				this.editWindow = true;
				if (id != '' && id != undefined) {
					this.getSignList(id)
				}
			},
			getCouponList() {
				let str = "?pageNum=" + this.couponFilter.pageNum + "&pageSize=" + this.couponFilter.pageSize;
				if (this.couponFilter.name) str += "&name=" + this.couponFilter.name;
				this.$http.get("dCoupon/list" + str).then(res => {
					this.couponList = res.body.data
					this.couponFilter.total = res.body.total
				})
			},
			getCouponPackage() {
				this.$http.post("couponPackage/findDCouponPackage", JSON.stringify(this.couponPackageFilter)).then(res => {
					this.couponPackageList = res.body.data;
					this.couponPackageFilter.total = res.body.total;
				})
			},
			deleteSign(id) {
				this.$confirm('是否确认删除', '提示', {
					confirmButtonText: '删除',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.get("marketing/deleteSign" + "?id=" + id).then(res => {
						if (res.body.code == 200) {
							this.$message.success("删除成功！")
							this.getSignList()
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			// 优惠券弹窗页码
			couponPage(val) {
				this.couponFilter.pageNum = val;
				this.getCouponList();
			},
			// 优惠券包弹窗页码
			couponPackagePage(val) {
				this.couponPackageFilter.pageNum = val;
				this.getCouponPackage()
			},
		}
	}
</script>

<style>
</style>